function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.1664 0.0023424C30.7359 0.123435 33.6473 4.66264 37.3502 7.34275C41.0622 10.0294 46.6998 11.2553 47.8441 15.6924C48.9908 20.1388 43.4616 23.5806 42.7057 28.1099C41.7173 34.033 46.3579 40.8177 42.839 45.6837C39.3362 50.5275 32.1431 51.0837 26.1664 50.9809C20.2607 50.8794 13.59 49.7337 9.90527 45.1175C6.35697 40.6722 9.97246 33.9779 8.26388 28.5528C6.58284 23.2152 -1.34888 19.6764 0.199173 14.2987C1.73185 8.97437 9.68996 9.41049 14.5435 6.73836C18.5646 4.52453 21.5778 -0.119259 26.1664 0.0023424Z",
  fill: "currentcolor"
});

function SvgIconBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackground);
export default __webpack_public_path__ + "static/media/icon-background.33359532.svg";
export { ForwardRef as ReactComponent };